import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import Button from "../../components/Shared/Button";
import { ButtonTypes } from "../../utils/consts";
import Spinner from "../../components/Shared/Spinner";
import Input from "../../components/Shared/Input";
import { useParams } from "react-router-dom";
import { GetAllCourseQuizzes } from "../../api/Courses/GetAllCourseQuizzes";
import { getStudentsbyCourse } from "../../api/Students/GetAllStudentsByCourse";
import { SkipQuiz } from "../../api/Courses/SkipQuiz";
type StudentsDTO = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  status: string;
};

const SkipCourseQuiz = () => {
  const { courseId } = useParams();

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [firstName, setFirstName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [studentSelected, setStudentSelected] = useState<StudentsDTO | null>(
    null
  );
  const [searchParams, setSearchParams] = useState({
    firstName: "",
    phone: "",
    email: "",
  });

  const handleSearch = () => {
    setSearchParams({ firstName, phone, email });
    setPage(1); // Reset page on new search
  };

  const { data: StudentsResponse, isLoading: isStudentsLoading } = useQuery({
    queryFn: () =>
      getStudentsbyCourse({
        courseId: courseId || "",
        page,
        limit,
        firstName: searchParams.firstName,
        status: "",
        phone: searchParams.phone,
        email: searchParams.email,
      }),
    queryKey: [
      "students",
      page,
      limit,
      searchParams.firstName,
      searchParams.phone,
      searchParams.email,
    ],
    staleTime: 0,
    refetchInterval: 0,
  });

  const { data: CoursesResponse, isLoading: isCourseLoading } = useQuery({
    queryFn: () => GetAllCourseQuizzes(courseId || ""),
    queryKey: ["courseQuizzes"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const course = CoursesResponse?.data?.course;

  const { mutate, isPending } = useMutation({
    mutationFn: SkipQuiz,
    onSuccess: () => {
      toast.success("Quiz Skipped Successfully");
    },
    onError: (e) => {
      toast.error(e.message || `Quiz already skipped`);
    },
  });

  const handleAssignCourse = () => {
    if (studentSelected) {
      mutate({
        studentId: studentSelected.id,
        courseId: courseId || "",
      });
    } else {
      toast.error("Please select a student.");
    }
  };

  const metadata = StudentsResponse?.data?.metaData;

  const handleNextPage = () => {
    if (metadata?.nextPage) {
      setPage(metadata.nextPage);
    }
  };

  const handlePrevPage = () => {
    if (metadata?.previousPage) {
      setPage(metadata.previousPage);
    }
  };

  return (
    <div className="py-7">
      {isPending && (
        <div className="fixed h-full inset-0  w-full bg-black/30 flex items-center justify-center z-[9999999999999999999999999999999999]">
          <Spinner />
        </div>
      )}
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">
        Skip Course Quiz
      </h1>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15">
        {isCourseLoading || isStudentsLoading ? (
          <div className="min-h-[50vh] flex justify-center items-center">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
              <Input
                name="FirstName"
                type="text"
                className="md:!space-y-0"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First Name"
                inputStyles="!rounded !h-[50px]"
              />
              <Input
                name="Phone"
                type="text"
                className="md:!space-y-0"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone"
                inputStyles="!rounded !h-[50px]"
              />
              <Input
                name="email"
                type="email"
                className="md:!space-y-0"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                inputStyles="!rounded !h-[50px]"
              />
              <Button
                className="!h-[50px] w-40 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                variant="primary"
                type={ButtonTypes.BUTTON}
                onClick={handleSearch}
              >
                Search
              </Button>
              <Button
                className="!h-[50px] w-56 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                variant="primary"
                type={ButtonTypes.SUBMIT}
                onClick={handleAssignCourse}
              >
                Skip Quiz
              </Button>
            </div>

            <p className="text-left bg-[#F5F6F8] border border-slate border-opacity-50 text-xl block w-full py-2.5 rounded-[10px] sm:h-12 h-10 px-4 text-slate mb-4">
              {course?.name}
            </p>

            {/* <Listbox
              value={selected}
              onChange={(val) =>
                setSelected(course?.quizzes.find((q) => q.id == val) || null)
              }
            >
              <div className="relative w-full mb-5">
                <h1 className="font-semibold text-lg mb-2">
                  Choose Quiz To Skip
                </h1>

                <Listbox.Button
                  className={`relative text-left bg-[#F5F6F8] border border-slate border-opacity-50 text-xl block w-full py-2.5 focus:outline-none  focus:border-secondary focus:ring-indigo-500/20 hover:border-primary hover:border-opacity-100 transition-all ease-in rounded-[10px] sm:h-12 h-10 px-4 text-slate`}
                >
                  <span className="block truncate text-base">
                    {selected ? selected.title : "Select a Quiz"}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center pr-2">
                    <ArrowIcon className="w-4 h-3" />
                  </span>
                </Listbox.Button>
                <Transition
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-[9999]">
                    {course?.quizzes.map((option, optionIdx) => (
                      <Listbox.Option
                        key={optionIdx}
                        className={({ active }) =>
                          `relative cursor-default  select-none py-2 pl-10 pr-4 ${
                            active
                              ? "bg-primary bg-opacity-50 text-white"
                              : "text-slate"
                          }`
                        }
                        value={option.id}
                      >
                        {({ selected }) => (
                          <>
                            <span
                              className={`block text-sm truncate ${
                                selected ? "font-medium" : "font-normal"
                              }`}
                            >
                              {option?.title}
                            </span>
                            {selected ? (
                              <span className="absolute inset-y-0 left-0 flex items-center  pl-3 text-amber-600">
                                <CheckIcon />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </Listbox> */}

            <h1 className="font-semibold text-lg mb-4">Select a Student</h1>
            <div className="grid grid-cols-3 gap-4 mb-8">
              {StudentsResponse?.data?.data?.length ? (
                StudentsResponse.data.data.map((student) => (
                  <div
                    key={student.id}
                    className={`border-4 p-4 rounded-lg transition-all duration-300 ${
                      studentSelected?.id === student.id
                        ? "border-primary"
                        : "border-gray-200"
                    } cursor-pointer`}
                    onClick={() => setStudentSelected(student as any)}
                  >
                    <p className="font-semibold">{student.fullName}</p>
                    <p className="font-semibold text-sm">{student.email}</p>
                    <p className="text-sm text-gray-600">{student.phone}</p>
                    <p
                      className={`text-sm ${
                        student.status === "active"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {student.status}
                    </p>
                  </div>
                ))
              ) : (
                <p className="text-center col-span-full">No students found</p>
              )}
            </div>

            <div className="flex justify-between">
              <Button
                className="!h-11 w-40 !text-sm font-bold rounded-md text-white !bg-[#4379EE] hover:!bg-primary"
                variant="secondary"
                type={ButtonTypes.BUTTON}
                onClick={handlePrevPage}
                disabled={!metadata?.previousPage}
              >
                Previous
              </Button>
              <span className="self-center">
                Page {metadata?.currentPage} of {metadata?.totalPages}
              </span>
              <Button
                className="!h-11 w-40 !text-sm font-bold rounded-md text-white !bg-[#4379EE] hover:!bg-primary"
                variant="secondary"
                type={ButtonTypes.BUTTON}
                onClick={handleNextPage}
                disabled={!metadata?.nextPage}
              >
                Next
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SkipCourseQuiz;
